import React, { useState, useContext, useEffect } from 'react'
import {
  FlexView,

} from '../components/common'
import { SmartContext } from 'stores/SmartStore'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { AppContext } from '../stores/AppStore'
import { UserContext } from 'stores/UserStore'
import { Input } from 'components/form'


const DataManagement = () => {
  const { t } = useTranslation()
  const { setPageSubtitle } = useContext(AppContext)
  const { registryLog } = useContext(UserContext)
  const history = useHistory()
  const DEFAULT_URL = 'collaborative-design/home'
  const [sellOrders, setSellOrders] = useState([])
  const {searchDataManagement} = useContext(SmartContext)

  function handleSellOrderInput(event){
    const value = event.target.value
    setSellOrders(value.split(','))
  }

  function handleKeyDown  (event){
    if (event.key === 'Enter') {
      if (sellOrders && sellOrders.length > 0) {
        onSubmit()
      }
    }
  }
  async function onSubmit(){
    try {
      // const response = await searchDataManagement(sellOrders)
      // if(response.data > 0 ){
        history.push(`/data-management/${sellOrders}`)
      // }
    } catch (error) {
      console.log(error)
    }
  }
  

  useEffect(() => {
    setPageSubtitle(t('data-management.pageTitle'))
    registryLog('client_in', DEFAULT_URL)
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <FlexView flexDirection="row" alignSelf="center" justifyContent="center" alignItems="center" margin="10% 0px !important" padding="10px" width="80%" >
      <Input 
       label={t('data-management.sell-order')+":"}
       fontSize="large"
       onChange={handleSellOrderInput}
       name="sellOrders"
       value={sellOrders}
       onKeyDown={handleKeyDown}
       message="Ex: 0000564437-10,0000558437-20,0000564437-30"
       width="100%" />
    </FlexView>
  )
}
export default DataManagement
